import { createSafeContext } from '../../Popover/subcomponents/create-safe-context.mjs';

const [CarouselProvider, useCarouselContext] = createSafeContext("Carousel component was not found in tree");

export { CarouselProvider, useCarouselContext };
